export default __webpack_public_path__ + "static/char-v-sp03-b76981d25a61ed8468226de6ecf52b16.mp4";